import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META, { type PersonTaggedType } from './useTrackPersonTagged.meta';

export type { PersonTaggedType } from './useTrackPersonTagged.meta';

export type UseTrackPersonTaggedParams = {
  type: PersonTaggedType;
  person_id: string;
};

export const useTrackPersonTagged = () => {
  const { track } = useAnalyticsUtilities();

  const trackPersonTagged = useCallback(
    (params: UseTrackPersonTaggedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackPersonTagged };
};
